// Preparation for the forthcoming routing refactor
export const routes = {
  inbound: {
    root: "/inbound",
    selectDelivery: "/inbound/select-delivery",
    scanRolli: "/inbound/scan-rolli",
    preDropping: "/inbound/pre-dropping",
    previewProducts: "/inbound/preview-products",
    outbound: "/inbound/outbound",
    outboundUnclaimed: "/inbound/outbound-unclaimed",
    outboundClaimed: "/inbound/outbound-claimed",
    editQuantity: "/inbound/edit-quantity",
    listVerification: "/inbound/list-verification",
    dropping: "/inbound/dropping",
    droppingManualSearch: "/inbound/dropping/search",
    droppingNoEANProducts: "/inbound/dropping/search/non-ean-products",
    manualSearch: "/inbound/search",
    noEANProducts: "/inbound/search/non-ean-products",
    sharedList: "/inbound/shared-list",
  },
  inventory: {
    root: "/inventory",
    restockingList: {
      // restocking flow
      root: "/inventory/restocking-list",
      publicList: "/inventory/restocking-list/public-list",
      moveItems: "/inventory/restocking-list/move-items",
      dropOff: "/inventory/restocking-list/drop-off",
      textSearch: "/inventory/restocking-list/search/text",
      shelfSearch: "/inventory/restocking-list/search/shelf",
    },
    stockCorrections: {
      root: "/inventory/stock-correction", // home to stock correction flow
      declare: "/inventory/stock-correction/declare",
      selectProduct: "/inventory/stock-correction/select-product",
    },
    bbdCorrections: {
      root: "/inventory/bbd-correction",
      declare: "/inventory/bbd-correction/declare",
      selectProduct: "/inventory/bbd-correction/select-product",
    },
    stockChecks: {
      // stockCheck flow
      root: "/inventory/stock-checks",
      quantity: "/inventory/stock-checks/:checkId/quantity",
      update: "/inventory/stock-checks/:checkId/update",
    },
    rollingInventoryChecks: {
      // rollingInventoryCheck flow
      root: "/inventory/rolling-inventory-checks",
      quantity: "/inventory/rolling-inventory-checks/:checkId/quantity",
      update: "/inventory/rolling-inventory-checks/:checkId/update",
    },
    freshChecks: {
      // freshCheck flow
      root: "/inventory/fresh-checks",
      quantity: "/inventory/fresh-checks/:checkId/quantity",
    },
    bbdChecks: {
      // bbdCheck flow
      root: "/inventory/bbd-check",
      declareExpired: "/inventory/bbd-check/:checkId/declare-expired",
      declareClosestBdd: "/inventory/bbd-check/:checkId/update",
    },
    eoyChecks: {
      // eoyChecks flow
      root: "/inventory/eoy-checks",
      detail: "/inventory/eoy-checks/:checkId/quantity",
    },
    eoyRecountChecks: {
      // eoyRecountChecks flow
      root: "/inventory/recount-checks",
      detail: "/inventory/recount-checks/:checkId/quantity",
    },
    tooGoodToGo: {
      root: "/inventory/too-good-to-go",
      prepareBag: "/inventory/too-good-to-go/prepare-bag",
      confirmation: "/inventory/too-good-to-go/confirmation",
      selectProduct: "/inventory/too-good-to-go/select-product",
      noEANProducts: "/inventory/too-good-to-go/no-ean-products",
    },
    inboundDeviationChecks: {
      // inbound deviation check flow
      root: "/inventory/inbound-deviation-checks",
      quantity: "/inventory/inbound-deviation-checks/:checkId/quantity",
    },
    shelfChanges: {
      // shelf change flow
      root: "/inventory/shelf-changes",
      detail: "/inventory/shelf-changes/:proposalId/detail",
    },
    batteryManagement: {
      // battery management flow
      root: "/inventory/battery-management",
      create: "/inventory/battery-management/:serialNumber/create",
      report: "/inventory/battery-management/:batteryId/report",
    },
    batteryCount: {
      // battery count flow
      root: "/inventory/battery-count",
      scan: "/inventory/battery-count/scan",
      create: "/inventory/battery-count/:serialNumber/create",
      missing: "/inventory/battery-count/missing",
    },
  },
  activities: {
    root: "/",
    deliveryCheckIn: {
      root: "/delivery-check-in",
      transportEquipmentCount: "/delivery-check-in/transport-equipment-count",
      transportEquipmentConfirm: "/delivery-check-in/transport-equipment-confirm",
    },
    featureFlagConfig: "/feature-flag-config",
    timedActivities: {
      list: "/timed-activities/list",
      details: "/timed-activities/:activityId",
    },
    transportEquipment: {
      precount: "/transport-equipment/precount",
    },
  },
  pickingV2: {
    root: "/v2/picking",
    start: "/v2/picking/start",
    manual: "/v2/picking/manual",
    containers: "/v2/picking/containers",
    shelves: "/v2/picking/shelves",
    end: "/v2/picking/end",
    incomplete: "/v2/picking/incomplete",
  },
} as const;
